import React, { FC } from 'react';
import { openModalByName, P } from 'ia-react-core';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { StyledLink, StyledNoBreakWrapper } from './TextWithModalLink.styles';

export interface TextWithModalLinkProps {
  translation: string;
  sectionName: string;
  modalName: string;
}

const TextWithModalLink: FC<TextWithModalLinkProps> = ({ translation, sectionName, modalName }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation(translation);

  return (
    <P>
      <StyledNoBreakWrapper>
        {t(`${sectionName}.textPart1`)}
        <StyledLink
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          onClick={(e: any) => {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            e.preventDefault();
            dispatch(openModalByName(modalName));
          }}
          href="#"
        >
          {t(`${sectionName}.textPart2`)}
        </StyledLink>
      </StyledNoBreakWrapper>
      {t(`${sectionName}.textPart3`)}
    </P>
  );
};

export default TextWithModalLink;
